import React, { Component } from 'react';
import axios from 'axios';
/*import ReactGA from 'react-ga';*/
import Recaptcha from 'react-google-invisible-recaptcha';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap'

class ContactForm extends Component {
    constructor(props) {
        super(props);

        console.info('REACT_APP_ENV:', process.env);

        this.state = {
            name: '',
            email: '',
            message: '',
            acceptTerms: false,
            verified: false,
            status: 'ready' // ready, loading, sent, failed
        }

        this.master = Object.assign({}, this.state);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.errorHandler = this.errorHandler.bind(this);
        this.submitData = this.submitData.bind(this);
    }

    componentWillUpdate(nextProps) {
        if (nextProps.location !== this.props.location) {
            this.setState({ status: 'ready' });
        }
    }

    handleSubmit(event) {
        event.preventDefault();
        const data = {
            Name: this.state.name,
            EmailAddress: this.state.email,
            Message: this.state.message,
        }

        if (this.showFormErrors() ) {
            this.setState({ status: 'loading' });
            this.submitData(data, this.errorHandler);
        }
    }

    submitData(data, errorHandler) {
        axios.request({
            url: `${process.env.GATSBY_REACT_APP_API_URL}/api/contact`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        }).then((response) => {
            const state = this.master;
            this.master.status = 'sent';
            this.setState(state);
            /*ReactGA.event({
                category: 'Contact Form',
                action: 'Submitted',
                //value: 'Locale: '+this.props.locale
            });*/
        }).catch(errorHandler);
    }

    errorHandler(error) {
        this.setState({ status: 'failed' });
    }

    handleChange(event) {
        let value = event.target.value;

        this.clearErrors();

        if (event.target.name === 'name') {
            if ( /\d/g.test(value) ) {
                value = value.replace(/\d/g, '');
            }
        }

        this.setState({
            [event.target.name]: value
        });
    }

    clearErrors() {
        const form = document.getElementById('contactForm');
        const inputs = form.querySelectorAll('input, select, textarea');
        const error = form.querySelector('#formError');

        error.textContent = '';

        for (var i = 0; i < inputs.length; ++i) {

            const parent = (inputs[1].name === 'terms') ? inputs[i].parentElement.parentElement : inputs[i].parentElement;
            parent.classList.remove('has-error');

        }

    }

    showFormErrors() {
        const form = document.getElementById('contactForm');
        const inputs = form.querySelectorAll('input, select, textarea');
        const error = form.querySelector('#formError');
        let errorMessages = [];
        let isFormValid = true;

        this.clearErrors();

        for (var i = 0; i < inputs.length; ++i) {
            const isInputValid = this.showInputError(inputs[i]);
            const parent = inputs[i].parentElement;

            if (typeof isInputValid === 'string') {
                errorMessages.push(isInputValid);
                parent.classList.add('has-error');
                isFormValid = false;
            }
        };

        if (errorMessages.length) {
            error.innerHTML += errorMessages[0];
        }

        return isFormValid;
    }

    showInputError(input) {
        const name = input.name;
        const validity = input.validity;

        if (input.name === 'name' && input.value) {
            input.value = input.value.trim();
            this.setState({
                [input.name]: input.value
            });
        }

        if (!validity.valid) {
            if (validity.valueMissing) {
                return 'Please fill in all fields';
            } else if (input.type === 'email' && (validity.typeMismatch || validity.patternMismatch) ) {
                return 'Invalid email address';
            }
        }

        return true;
    }

    render() {
        const { handleSubmit, pristine, submitting, disabled } = this.props;
        const { status } = this.state;
        switch (status) {
            case 'loading':
                return <div className="formMessage">{"Sending email..."}</div>;
                break;
            case 'sent':
                return <div className="formMessage">{"Email sent successfully"}</div>;
                break;
            case 'failed':
                return <div className="formMessage">{"Sending failed"}</div>;
                break;
            default:
                return (
                    <Col md="12" className="contactForm">
                        <form id="contactForm" onSubmit={this.handleSubmit} noValidate>
                            <div className="inputWrapper">
                                <input name="name" className="input" type="text" placeholder="Name" value={this.state.name} onChange={this.handleChange} required />
                            </div>
                            <div className="inputWrapper">
                                <input name="email" className="input" type="email" placeholder="Email Address" value={this.state.email} pattern="^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$" onChange={this.handleChange} required />
                            </div>
                            <div className="inputWrapper">
                                <textarea name="message" className="input" placeholder="Message" value={this.state.message} onChange={this.handleChange} required></textarea>
                            </div>

                            <div className="readMore">
                            <input type="submit" value="Send message" />

                                <div className="chevron green" />
                                <div className="chevron green" />
                            </div>
                            <div id="formError"></div>
                        </form>
                    </Col>
                );
                break;
        }
    }
}

ContactForm.propTypes = {
    disabled: PropTypes.bool,

};

ContactForm.defaultProps = {
    disabled: true,

};


export default ContactForm


// WEBPACK FOOTER //
// ./src/components/contact-form.js